import { render, staticRenderFns } from "./credentialsManager.vue?vue&type=template&id=70b05339&lang=pug"
import script from "./credentialsManager.vue?vue&type=script&lang=js"
export * from "./credentialsManager.vue?vue&type=script&lang=js"
import style0 from "./credentialsManager.vue?vue&type=style&index=0&id=70b05339&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports